import { ReactNode } from "react";

import {
  BulkActionActionConfirmationTabs,
  BulkActionItemID,
  BulkActionsStep,
  BulkActionsVariant,
} from "components/BulkActions/types";
import BulkActionsDrawerActionStepsFooter from "components/BulkActions/Drawer/ActionSteps/Footer";
import BulkActionsDrawerActionStepsConfirmation from "components/BulkActions/Drawer/ActionSteps/Confirmation";
import BulkActionsDrawerActionStepsConfirmationEmptyTab from "components/BulkActions/Drawer/ActionSteps/Confirmation/EmptyTab";
import { FlowsProjectRoleBindingView } from "shared/Flows/Projects/useFlowsProject/types";

import {
  FlowsProjectRolesBulkActionsAnalyticsPayload,
  FlowsProjectRolesBulkActionItem,
  FlowsProjectRolesMutationVariables,
} from "./types";
import FlowsProjectDetailsRolesBulkActionsSelectedItem from "./SelectedRoleItem";
import FlowsProjectDetailsRolesBulkActionsConfirmActionForm from "./ConfirmActionForm";

type FlowsProjectDetailsRolesBulkActionsConfirmationViewProps = {
  applicableItems: FlowsProjectRoleBindingView[];
  skippedItems: FlowsProjectRoleBindingView[];
  onItemDismiss: (id: BulkActionItemID) => void;
  selectedBulkAction: FlowsProjectRolesBulkActionItem;
  onConfirm: (
    mutationVariables: FlowsProjectRolesMutationVariables,
    analyticsPayload: FlowsProjectRolesBulkActionsAnalyticsPayload
  ) => void;
  onCancel: () => void;
  customConfirmationMessage?: ReactNode;
};

const FlowsProjectDetailsRolesBulkActionsConfirmationView = ({
  applicableItems,
  skippedItems,
  onItemDismiss,
  selectedBulkAction,
  onConfirm,
  onCancel,
  customConfirmationMessage,
}: FlowsProjectDetailsRolesBulkActionsConfirmationViewProps) => {
  const getItems = (tab: BulkActionActionConfirmationTabs) => {
    if (tab === BulkActionActionConfirmationTabs.Applicable) {
      return applicableItems;
    }

    return skippedItems;
  };

  return (
    <>
      <BulkActionsDrawerActionStepsConfirmation
        applicableCount={applicableItems.length}
        skippedCount={skippedItems.length}
      >
        {({ currentTab }) =>
          getItems(currentTab).length === 0 ? (
            <BulkActionsDrawerActionStepsConfirmationEmptyTab currentTab={currentTab} />
          ) : (
            getItems(currentTab).map((item) => (
              <FlowsProjectDetailsRolesBulkActionsSelectedItem
                key={item.id}
                item={item}
                onDismiss={onItemDismiss}
                itemCategory={currentTab}
                step={BulkActionsStep.ActionConfirmation}
              />
            ))
          )
        }
      </BulkActionsDrawerActionStepsConfirmation>

      <BulkActionsDrawerActionStepsFooter>
        <FlowsProjectDetailsRolesBulkActionsConfirmActionForm
          variant={BulkActionsVariant.Drawer}
          action={selectedBulkAction}
          onConfirm={onConfirm}
          onCancel={onCancel}
          customConfirmationMessage={customConfirmationMessage}
        />
      </BulkActionsDrawerActionStepsFooter>
    </>
  );
};

export default FlowsProjectDetailsRolesBulkActionsConfirmationView;
